var UA = require('../internals/engine-user-agent');

module.exports = /MSIE|Trident/.test(UA);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-is-ie-or-edge.js
// module id = 6300
// module chunks = 25